import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    backgroundColor: "#fff",
    minHeight: "calc(100vh - 60px)",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
}));
